import React from 'react';
import PropTypes from 'prop-types';
import style from './Shimmer.module.scss';

const DataShimmer = ({ id }) => {
  const shimmerListArr = Array.from({ length: id === 'ecsfaq' ? 7 : 9 }, (_, i) => i + 1);
  const shimmerPhArr = Array.from({ length: id === 'ecsfaq' ? 2 : 1 }, (_, i) => i + 1);
  const shimmerPbArr = Array.from({ length: id === 'ecsfaq' ? 2 : 1 }, (_, i) => i + 1);
  return (
    <div className={`${style.shimmer_leadsportal} `}>
      {id === 'ecsfaq' && (
        <>
          <div className="p-20">
            <div className={`${style.shimmer_portal_heading} mb-20`}>
              {shimmerPhArr.map(({ phitems }) => (
                <div key={phitems} className={`${style.shimmer_portal_head} ${style.shimmerwrap}`} />
              ))}
            </div>
            <div className={`${style.shimmer_portalbox} pt-20 pl-15 pr-15 pb-20`}>
              <div className={`${style.shimmer_portalbox__row1} ${style.shimmerwrap}`} />
              {shimmerPbArr.map(({ pbitems }) => (
                <div key={pbitems} className={`${style.shimmer_portalbox__row2} mt-10 ${style.shimmerwrap}`} />
              ))}
            </div>
          </div>
          <div className="p-20">
            <div className={`${style.shimmer_portal_heading} mb-20`}>
              <div className={`${style.shimmer_portal_head} ${style.shimmerwrap}`} />
            </div>
            <ul className="mt-10">
              {shimmerListArr.map(({ listitems }) => (
                <li key={listitems} className={`${style.shimmer_portal_faq} ${style.shimmerwrap}`} />
              ))}
            </ul>
          </div>
        </>
      )}
      {id === 'leadsfaq' && (
        <>
          <div className="p-20">
            <div className={`${style.shimmer_portal_leadsheading} mb-20`}>
              <div className={`${style.shimmer_portal_leadshead} ${style.shimmerwrap}`} />
            </div>
            <div className="mt-10">
              <div className={`${style.shimmer_portal_leadsfaq} ${style.shimmerwrap}`} />
            </div>
            <div className="p-20">
              <ul className="mt-10">
                {shimmerListArr.map((items) => (
                  <li key={items} className={`${style.shimmer_portal_leadsfaq} ${style.shimmerwrap}`} />
                ))}
              </ul>
            </div>
            <div className={`${style.shimmer_portal_leadsheading} mb-20`}>
              <div className={`${style.shimmer_portal_leadshead} ${style.shimmerwrap}`} />
            </div>
            <div className={`${style.shimmer_leadsportalbox} pt-20 pl-15 pr-15 pb-20`}>
              <div className={`${style.shimmer_leadsportalbox__row1} ${style.shimmerwrap}`} />
              <div className={`${style.shimmer_leadsportalbox__row2} mt-10 ${style.shimmerwrap}`} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default DataShimmer;

DataShimmer.propTypes = {
  id: PropTypes.string,
};
